import { render, staticRenderFns } from "./Desadv.vue?vue&type=template&id=4afd1f73&"
import script from "./Desadv.vue?vue&type=script&lang=js&"
export * from "./Desadv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports